var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A4A4A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    className: "st0",
    d: "M14.8,47.3c-4.8,0.1-9.2-2.8-11.2-7.2C1.4,35.8,2,30.5,5.1,26.7c2.9-3.8,5.9-7.6,8.8-11.3 s5.9-7.6,8.9-11.3c3.1-3.9,8.7-4.5,12.6-1.4c3.8,3,4.5,8.5,1.6,12.4C31,22.9,24.9,30.7,18.8,38.5c-0.8,1-2,1.7-3.3,1.9 C12.6,41,9.8,39,9.3,36.1c-0.3-1.5,0.1-3.1,1.1-4.3c4.4-5.6,8.7-11.2,13.1-16.8c-0.2-1.3,0.7-2.5,2-2.7c1.3-0.2,2.5,0.7,2.7,2 c0.2,1.2-0.7,2.4-1.9,2.7c-4.4,5.6-8.7,11.1-13.1,16.7c-0.8,0.7-0.8,2-0.1,2.7c0.7,0.8,2,0.8,2.7,0.1c0.1-0.1,0.3-0.3,0.4-0.5 c6-7.6,11.9-15.3,17.9-22.9c1.9-2.3,1.6-5.8-0.7-7.7c-0.1,0-0.1-0.1-0.2-0.1c-2.3-1.9-5.8-1.6-7.7,0.8c-0.1,0.1-0.1,0.1-0.2,0.2 c-6,7.6-11.9,15.2-17.8,22.8c-1.4,1.7-2.1,3.9-1.9,6.1c0.2,3.8,2.8,7.1,6.5,8.2c3.7,1.2,7.7-0.1,10-3.3c6.2-8,12.5-15.9,18.7-23.9 c0,0,0,0,0-0.1c0-1.3,1.1-2.4,2.4-2.4c1.3,0,2.4,1.1,2.4,2.4c0,1.2-1,2.3-2.2,2.4c-6.3,8.1-12.6,16.3-19,24.3 c-2.2,2.8-5.7,4.5-9.3,4.4C15.1,47.3,14.9,47.3,14.8,47.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/Attach.06dd9696c996827391ef6ef8a3dfa800.svg";
export { ForwardRef as ReactComponent };